import cssVariables from 'tfs.css-variables'

export default {
  container: {
    display: 'flex',
    alignSelf: 'flex-end',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: cssVariables.colorBlue,
    padding: '.5rem',
    borderRadius: '.4rem',
    filter: 'box-shadow(0 5px 10px 0 rgba(0, 0, 0, 0.15))',
    height: '2.5rem',
  },
  title: {
    marginBottom: '0',
    marginTop: '0',
    color: cssVariables.colorWhite,
  },
}
